module.exports = __webpack_public_path__ + "static/img/burrito.0ea3aa8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/burrito.gif
// module id = NuiW
// module chunks = 4